import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const MOSCOW_TIMEZONE = 'Europe/Moscow';

export function moscowCalendarDay(date: Date | number | string): string {
    return dayjs(date).tz(MOSCOW_TIMEZONE).format('YYYY-MM-DD');
}

// First entry is `day` itself, so a 7-day fallback window means maxDays: 7 (8 candidates).
export function precedingMoscowDays(day: string, maxDays: number): string[] {
    const start = dayjs.tz(day, MOSCOW_TIMEZONE);
    const days: string[] = [];
    for (let i = 0; i <= maxDays; i++) {
        days.push(start.subtract(i, 'day').format('YYYY-MM-DD'));
    }
    return days;
}
